import React, { useState } from "react";
import { Theme, FormControl } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useAuth } from "../services/auth-check";
import Button from "../components/custom-button";
import Select from "react-select";
import Icon from "../components/icon";
import FormInput from "../components/form-input";
import axios from "axios";
import { Modal } from "rsuite";
import { useHistory, useRouteMatch } from "react-router-dom";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import _ from "lodash";
import { globalStore, roomTypes } from "../stores/global";
import { t } from "../i18n";
import Language from "@material-ui/icons/Language";
import GlobalStorage from "../utils/custom-storage";
import { API_COMMON_URL, API_V1_USERS } from "../services/ihr-meet-api";

const useStyles = makeStyles((theme: Theme) => ({
  formControl: {
    minWidth: "300px",
    maxWidth: "300px",
  },
}));

const data = JSON.parse(localStorage.getItem("UserFullData") as string);
const codeCountry =
  data && data.country_id
    ? JSON.parse(localStorage.getItem("countryCode") as string)
    : "";

type SessionInfo = {
  email: string;
  password: string;
  roomType: number;
  forgetPasswordEmail: string;
  name: string;
  currentPassword: string;
  newPassword: string;
  confirmPassword: string;
  country: any;
  country_code: any;
  phone: string;
};

const defaultState: SessionInfo = {
  email: data ? data.email : "",
  password: "",
  roomType: 2,
  forgetPasswordEmail: "",
  name: data ? data.name : "",
  currentPassword: "",
  newPassword: "",
  confirmPassword: "",
  country: data && data.country_id ? data.country_id : "",
  country_code: codeCountry && codeCountry ? codeCountry : "",
  phone: data && data ? data.phone : "",
};
function HomePage() {
  document.title = t(`home.short_title.title`);

  const data = JSON.parse(localStorage.getItem("UserFullData") as string);

  const classes = useStyles();
  const history = useHistory();

  const { params } = useRouteMatch<{ type: string }>();

  const [session, setSessionInfo] = useState<SessionInfo>(defaultState);
  const [, setHomeActive] = React.useState(false);
  const [, setProfile] = React.useState(false);
  const [, setSettings] = React.useState(false);

  const [countries, getCountriesdata] = useState<any[]>([]);
  const [lang, setLang] = useState<string>("");

  const [countryCode, setCountryCode] = useState<any[]>([]);

  const [countryValue, setCountryValue] = useState(data && data.country_code);
  const [countryLabel, setCountryLabel] = useState("");

  const [required, setRequired] = useState<any>({} as any);
  const [addCodeModalShow, setAddCodeModalShow] = React.useState(false);

  const [passwordLength, setPasswordLength] = React.useState(false);

  const changelang = (lang: string) => {
    if (lang == "ar") {
      localStorage.setItem("language", `${JSON.stringify("ar")}`);
      document.documentElement.lang = "ar";
      globalStore.setLanguage("ar");
    } else {
      localStorage.setItem("language", `${JSON.stringify("en")}`);
      document.documentElement.lang = "en";
      globalStore.setLanguage("en");
    }
  };

  const handleChangePasswordUpdate = () => {
    if (session.password.length < 6) {
      setPasswordLength(true);
      //return;
    } else {
      setPasswordLength(false);
    }
    if (
      !session.confirmPassword ||
      !session.currentPassword ||
      !session.newPassword
    ) {
      setRequired({ ...required, missingField: t("requiredField") });
      return;
    }

    const data = JSON.parse(localStorage.getItem("UserFullData") as string);
    const accessToken = JSON.parse(
      localStorage.getItem("accessToken") as string
    );

    if (session.newPassword !== session.confirmPassword) {
      globalStore.showToast({
        type: "error",
        message: t("toast.newPasswordWrong"),
      });
    } else {
      axios({
        method: "PUT",
        url: `${API_V1_USERS}/accounts/change-password`,
        headers: {
          Authorization: "Bearer " + accessToken,
        },
        data: {
          current_password: session.currentPassword,
          new_password: session.newPassword,
          new_password_confirmation: session.confirmPassword,
        },
      })
        .then(
          (response: any) => {
            setAddCodeModalShow(false);
            setHomeActive(false);
            setProfile(false);
            session.confirmPassword = "";
            session.currentPassword = "";
            session.newPassword = "";
            globalStore.showToast({
              type: "rtmClient",
              message: t("toast.passwordChanged"),
            });
          },
          (error: any) => {
            globalStore.showToast({
              type: "rtmClient",
              message: t("toast.currentPasswordIsWrong", {
                reason: error.message,
              }),
            });
          }
        )
        .finally(() => {
          globalStore.stopLoading();
        });
    }
  };

  React.useEffect(() => {
    const lang = GlobalStorage.getLanguage().language;

    const data = JSON.parse(localStorage.getItem("UserFullData") as string);
    const codeCountry =
      data && data.country_id
        ? JSON.parse(localStorage.getItem("countryCode") as string)
        : "";

    session.name = data ? data.name : "";
    session.email = data ? data.email : "";
    session.country_code = codeCountry ? codeCountry : "";
    session.phone = data ? data.phone : "";
    session.country = data ? data.country_id : "";

    if (!data) {
      return;
    }

    const fetchData = async () => {
      const lang =
        JSON.parse(localStorage.getItem("language") as string) === "en-US" ||
        JSON.parse(localStorage.getItem("language") as string) === "en"
          ? "en"
          : "ar";
      const response = await axios(`${API_COMMON_URL}/countries`, {
        method: "GET",
        headers: {
          "x-localization": lang,
        },
      });
      getCountriesdata(response.data.data);

      const countryDataCode = _.find(
        response.data.data,
        (country) => country.id === data.country_id
      );
      setCountryValue(countryDataCode.id);
      setCountryLabel(countryDataCode.name);

      const userData = await axios.get(`${API_V1_USERS}/${data.id}`);
      localStorage.setItem(
        "UserFullData",
        `${JSON.stringify(userData.data.data)}`
      );
    };

    fetchData();
    setLang(lang);
  }, []);

  const findCountryCode = (countryId: any) => {
    let data = _.filter(countries, { id: countryId });
    setCountryCode(data && data[0].country_code);
    session.country_code = data && data[0].country_code;
    localStorage.setItem(
      "countryCode",
      `${JSON.stringify(data[0].country_code)}`
    );
  };

  const [open, setOpen] = React.useState(false);

  const handleConfirm = () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("UserData");
    localStorage.removeItem("UserFullData");
    localStorage.removeItem("countryCode");
    history.push("/login");
    setOpen(false);
  };

  const handleClick = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSetting = (evt: any) => {
    history.push({ pathname: `/settings` });
    setSettings(true);
    setHomeActive(false);
    setProfile(false);
  };

  const handleSubmit = () => {
    if (
      !session.name ||
      !session.email ||
      !session.country_code ||
      !session.phone
    ) {
      setRequired({ ...required, missingField: t("requiredField") });
      return;
    }
    globalStore.showLoading();
    axios
      .put(`${API_V1_USERS}/${data.id}`, {
        name: session.name,
        email: session.email,
        country_id: session.country,
        phone: session.phone,
        user_type_id: data.user_type_id,
        country_code: session.country_code,
      })
      .then(
        (response) => {
          if (response.data.data) {
            globalStore.showToast({
              type: "msg",
              message: t("toast.dataSaved"),
            });
            axios
              .get(`${API_V1_USERS}/${response.data.data.id}`)
              .then((res) => {
                localStorage.setItem(
                  "UserFullData",
                  `${JSON.stringify(res.data.data)}`
                );
              });
          }
          history.push(`/`);
        },
        (error) => {
          globalStore.showToast({
            type: "rtmClient",
            message: t("toast.email_exists", { reason: error.message }),
          });
        }
      )
      .finally(() => {
        globalStore.stopLoading();
      });
  };

  const [authorized, redirect] = useAuth("EDIT_PROFILE");

  if (!authorized) {
    redirect();
    return null;
  }

  return (
    <>
      <div className={`setting-container`}>
        <div
          onClick={(evt: any) => {
            handleClick();
          }}
          className="logout-button"
        >
          <span style={{ color: "white", cursor: "pointer" }}>
            {t("logout")}
          </span>
          <Icon className="icon-exit-white home-" />
        </div>
        {lang == "ar" ? (
          <button className="lang-btn" onClick={() => changelang("en")}>
            <span>English</span>
            <Language />
          </button>
        ) : (
          <button className="lang-btn" onClick={() => changelang("ar")}>
            <span>عربي</span> <Language />
          </button>
        )}
      </div>
      <Dialog
        className="logout-dialog"
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {t("areYouSureToLogOut")}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleConfirm} name={t("logout")} />
          <Button onClick={handleClose} name={t("close")} />
        </DialogActions>
      </Dialog>
      <div
        className={`flex-container  edit-profile home-cover-web ${JSON.parse(
          localStorage.getItem("language") as string
        )}`}
      >
        <div className="edit-profile">
          <div className="header">
            <div className="logo"></div>
          </div>
          <h2>{t("editProfile")}</h2>
          <div className="position-content flex-direction-column">
            <FormControl className={`${classes.formControl} input-margin`}>
              <FormInput
                placeholder={t("fullName")}
                value={session.name}
                onChange={(val: string) => {
                  setSessionInfo({
                    ...session,
                    name: val,
                  });
                }}
                requiredText={session.name ? "" : required.missingField}
              />
            </FormControl>
            <FormControl className={`${classes.formControl} input-margin`}>
              <FormInput
                disabled
                placeholder={t("email")}
                value={session.email}
                onChange={(val: string) => {
                  setSessionInfo({
                    ...session,
                    email: val,
                  });
                }}
                type="email"
                requiredText={session.email ? "" : required.missingField}
              />
            </FormControl>

            <FormControl className={classes.formControl}>
              <Select
                onChange={(evt: any) => {
                  session.country = evt.value;
                  setCountryValue(evt.value);
                  setCountryLabel(evt.label);
                  findCountryCode(evt.value);
                }}
                options={countries.map((it: any) => ({
                  value: it.id,
                  label: it.name,
                }))}
                value={{ value: countryValue, label: `${countryLabel}` }}
              />
            </FormControl>
            <div className="flex-row-mobile">
              <FormControl className={classes.formControl + " country-field"}>
                <FormInput
                  className="country-code"
                  placeholder={"Country Code"}
                  value={session.country_code}
                  disabled
                  onChange={(val: number) => {
                    setSessionInfo({
                      ...session,
                      country_code: countryCode,
                    });
                  }}
                  requiredText={session.phone ? "" : required.missingField}
                />
              </FormControl>

              <FormControl className={classes.formControl + " mobile-field"}>
                <FormInput
                  className="mobile-number"
                  placeholder={t("mobile")}
                  value={session.phone}
                  onChange={(val: string) => {
                    setSessionInfo({
                      ...session,
                      phone: val,
                    });
                  }}
                  type="number"
                  requiredText={session.phone ? "" : required.missingField}
                />
              </FormControl>
            </div>

            <Button name={t("save")} onClick={handleSubmit} />
            <Button
              className="forget-password-butt"
              name={t("changePassword")}
              onClick={() => {
                setAddCodeModalShow(true);
              }}
            />
          </div>
          <div className="icons">
            <Icon
              className={"icon-home"}
              onClick={() => {
                setHomeActive(true);
                history.push(`/`);
              }}
            />
            <Icon
              className={"icon-profile active"}
              onClick={() => {
                //setAddCodeModalShow(true);
                setSettings(false);
                setHomeActive(false);
                setProfile(true);
              }}
            />
            <Icon className={"icon-setting"} onClick={handleSetting} />
          </div>
        </div>

        <Modal
          show={addCodeModalShow}
          dialogClassName={`change-password-modal ${JSON.parse(
            localStorage.getItem("language") as string
          )}`}
          backdropClassName={"backdrop-change-password-modal"}
          onHide={() => {
            session.confirmPassword = "";
            session.currentPassword = "";
            session.newPassword = "";
            setAddCodeModalShow(false);
            setSettings(false);
            setHomeActive(true);
            setProfile(false);
          }}
        >
          <Modal.Header />
          <Modal.Body>
            <div className="change-password">
              <h5 style={{ marginBottom: "5px" }}>{t("changePassword")}</h5>
              <FormControl className={classes.formControl}>
                <FormInput
                  placeholder={t("currentPassword")}
                  value={session.currentPassword}
                  onChange={(val: string) => {
                    if (session.currentPassword.length < 5) {
                      setPasswordLength(true);
                    } else setPasswordLength(false);
                    setSessionInfo({
                      ...session,
                      currentPassword: val,
                    });
                  }}
                  type="password"
                  requiredText={
                    session.currentPassword ? "" : required.missingField
                  }
                />
                {passwordLength ? (
                  <p className="password-length">{t("passwordLength")}</p>
                ) : (
                  ""
                )}
              </FormControl>

              <FormControl className={classes.formControl}>
                <FormInput
                  placeholder={t("newPassword")}
                  value={session.newPassword}
                  onChange={(val: string) => {
                    if (session.newPassword.length < 5) {
                      setPasswordLength(true);
                    } else setPasswordLength(false);
                    setSessionInfo({
                      ...session,
                      newPassword: val,
                    });
                  }}
                  type="password"
                  requiredText={
                    session.newPassword ? "" : required.missingField
                  }
                />
                {passwordLength ? (
                  <p className="password-length">{t("passwordLength")}</p>
                ) : (
                  ""
                )}
              </FormControl>
              <FormControl className={classes.formControl}>
                <FormInput
                  placeholder={t("confirmPassword")}
                  value={session.confirmPassword}
                  onChange={(val: string) => {
                    if (session.confirmPassword.length < 5) {
                      setPasswordLength(true);
                    } else setPasswordLength(false);
                    setSessionInfo({
                      ...session,
                      confirmPassword: val,
                    });
                  }}
                  type="password"
                  requiredText={
                    session.confirmPassword ? "" : required.missingField
                  }
                />
                {passwordLength ? (
                  <p className="password-length">{t("passwordLength")}</p>
                ) : (
                  ""
                )}
              </FormControl>

              <Button name={t("update")} onClick={handleChangePasswordUpdate} />
            </div>
          </Modal.Body>
          <Modal.Footer>
            <span
              style={{ cursor: "pointer", color: "#ffff" }}
              onClick={() => {
                session.confirmPassword = "";
                session.currentPassword = "";
                session.newPassword = "";
                setAddCodeModalShow(false);
                setSettings(false);
                setHomeActive(true);
                setProfile(false);
              }}
            >
              {t("toast.cancel")}
            </span>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
}
export default React.memo(HomePage);
